import { Model as o } from "../../../model.js";
class l extends o {
  constructor(e) {
    super(), this.pixelId = e.pixelId;
  }
}
export {
  l as FacebookAnalyticsModel
};
//# sourceMappingURL=facebook.model.js.map
